import React, {useEffect, useState} from 'react'
import Topbar from '../../components/topbar/Topbar'
import { useHistory } from 'react-router'
import {verifyCertificate,generateMembershipCertificate} from '../../actions'
import {useDispatch, useSelector} from 'react-redux'
import { v4 as uuidv4 } from 'uuid'
import { Container} from 'react-bootstrap'
import { Row, Col } from 'react-bootstrap'

 


const CerificateValidation = ()=>{

    const history = useHistory()

    const apiResponse = useSelector(state=>{
        const {certificates,fetchFile} = state
        const {status} = certificates
        const {file} = fetchFile

        return{
            status,
            file
        }
    })

    const [hasDownloaded, setHasDownloaded] = useState(false)
    const [download, setDownload] = useState(false)


    const dispatch = useDispatch()

    const params = new URLSearchParams(window.location.search)
    const certificateId = params.get('certificateId') || uuidv4 ()

    useEffect(()=>{
        if(verifyCertificate){
            dispatch(verifyCertificate(certificateId))
        }
    },[])

    
    useEffect(()=>{
        if(apiResponse.file?.fileText != null && !hasDownloaded && download){
            var a = document.createElement("a");
            a.href =  "data:image/" +apiResponse.file?.type +";base64," + apiResponse.file?.fileText; 
            a.download = apiResponse.file?.name || 'File' + "." + apiResponse.file?.type || ''; 
            a.click();
            setHasDownloaded(true)
        }
    },[apiResponse.file])


    const generateCertificate = (fileText)=>{
     
       let url 
        if(fileText!== '' && fileText !== undefined ){
            url = encodeURIComponent(fileText.substring(fileText.indexOf("/tmp"), fileText.length))
            dispatch(generateMembershipCertificate(url))
        }
        setDownload(true)
        setHasDownloaded(false)
    }

    return(
        <div className="email-validation-container">
            <Topbar 
                hasName={true}
                hasLogo={true}
            />
            <div className="email-validation-header">
            </div>
            <div className="certificate-validation-card" style={{padding: 20}}>
                <span style={{textDecoration: 'underline'}}>Certificate Validation</span>
                {apiResponse.status?.status?.toLowerCase() === 'valid' ?
                    <Container fluid style={{width: '70%', marginTop: '80px'}}>
                        <Row>
                            <Col className='validation-text'>Status</Col>
                            <Col className='table-status-assigned'>{apiResponse.status?.status}</Col>
                        </Row>
                        <hr/>
                        <Row>
                            <Col className='validation-text'>Names</Col>
                            <Col>{apiResponse.status?.holder}</Col>
                        </Row>
                        <hr/>

                        <Row>
                            <Col className='validation-text'>Reg No</Col>
                            <Col>{apiResponse.status?.regNumber}</Col>
                        </Row>
                        <hr/>

                        <Row>
                            <Col className='validation-text'>Field</Col>
                            <Col>{apiResponse.status?.discipline}</Col>
                        </Row>
                        <hr/>
                        <Row>
                            <Col className='validation-text'>Valid until</Col>
                            <Col>{(apiResponse.status?.expirationDate || 'N/A')}</Col>
                        </Row>
                    </Container> :
                    <Container fluid style={{width: '70%', marginTop: '80px'}}>
                        <Row>
                            <Col className='validation-text'>Status</Col>
                            <Col className='table-status-incomplete'>{apiResponse.status?.status}</Col>
                        </Row>
                        <hr/>
                    </Container>}
                    <h1 style={{fontSize: 14, cursor: 'pointer'}} onClick={()=>generateCertificate(apiResponse.status?.certificate?.fileText)}>download Certificate</h1>
            </div>
        </div>
    )

}
export default CerificateValidation